<template>
  <b-modal
    ref="modal"
    title="Update Team Info"
    ok-title="Apply"
    @ok="onSave">
    <b-alert
      variant="warning"
      show>
      <b-icon-exclamation-triangle
        scale="1.25"
        class="mr-2" />
      Take care when editing these values!
    </b-alert>
    <b-form
      ref="form"
      novalidate
      :validated="validated">
      <b-form-group
        label="Team ID"
        :label-cols="labelCols">
        <b-input
          v-model="config.teamID"
          number
          readonly
          plaintext />
      </b-form-group>
      <b-form-group
        label="Club"
        :label-cols="labelCols">
        <b-input
          v-model="config.club"
          required />
      </b-form-group>
      <b-form-group
        label="Full Name"
        :label-cols="labelCols">
        <b-input
          v-model="config.clubFullName"
          required />
      </b-form-group>
      <b-form-group
        label="Sport Code"
        :label-cols="labelCols">
        <b-input
          v-model="config.sportCode"
          required />
      </b-form-group>
      <b-form-group
        label="Team Code"
        :label-cols="labelCols">
        <b-input
          v-model="config.teamCode"
          required />
      </b-form-group>
      <b-form-group
        label="File Code"
        :label-cols="labelCols">
        <b-input
          v-model="config.fileCode"
          required />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: "EditTeamInfoModal",
  props: {
    teamID: {
      type: Number,
      required: true,
    },
    club: {
      type: String,
      required: true,
    },
    clubFullName: {
      type: String,
      required: true,
    },
    sportCode: {
      type: String,
      required: true,
    },
    teamCode: {
      type: String,
      required: true,
    },
    fileCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      validated: false,
      labelCols: 4,
      config: {
        teamID: this.teamID,
        club: this.club,
        clubFullName: this.clubFullName,
        sportCode: this.sportCode,
        teamCode: this.teamCode,
        fileCode: this.fileCode,
      },
    }
  },
  methods: {
    show() {
      this.$refs.modal.show()
    },
    onSave(evt) {
      if (!this.$refs.form.checkValidity()) {
        evt.preventDefault()
        this.validated = true
        return
      }
      this.$emit("input", this.config)
      this.validated = false
    },
  },
}
</script>
